<template>
  <a-modal
    title="导入"
    centered
    :width="740"
    :mask-closable="false"
    :visible="showUploadForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <a-form-model-item label="操作类型" prop="ope_type">
            <a-radio-group v-model="model.ope_type">
              <a-radio-button :value="1">关停项目</a-radio-button>
              <a-radio-button :value="2">删除项目</a-radio-button>
              <a-radio-button v-if="master" :value="3">删除违规素材</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="付费类型" prop="pay_type" v-if="model.ope_type == 3">
            <a-radio-group v-model="model.pay_type">
              <a-radio-button :value="1">收费</a-radio-button>
              <a-radio-button :value="2">免费</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="下载模版" help="点击下载模版，模版需对应媒体操作！">
            <a :href="publicCsv" target="_blank">{{ opeTypeName }}模版</a>
          </a-form-model-item>
          <a-form-model-item label="媒体" prop="media" :help="`请选中需要广告主项目的所属媒体！`">
            <a-select allow-clear placeholder="媒体" :default-value="model.media" v-model="model.media" show-search option-filter-prop="children" :disabled="true">
              <a-select-option :value="item.id" v-for="item in medias" :key="item.id" >
                  {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="表格文件" prop="csv">
            <template slot="help">
              <span class="danger-help">{{ helpTitle }}</span>
            </template>
            <a-upload accept=".csv" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
              <a-button v-if="fileList.length === 0"> <a-icon type="upload" /> 选择文件 </a-button>
            </a-upload>
          </a-form-model-item>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Upload';
</style>

<script>
import Upload from './Upload'
export default Upload
</script>
